import { render, staticRenderFns } from "./myCertificate.vue?vue&type=template&id=5530e6a0&scoped=true"
import script from "./myCertificate.vue?vue&type=script&setup=true&lang=js"
export * from "./myCertificate.vue?vue&type=script&setup=true&lang=js"
import style0 from "./myCertificate.vue?vue&type=style&index=0&id=5530e6a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5530e6a0",
  null
  
)

export default component.exports